import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import { Fade, Tooltip } from '@mui/material';

import useStyles from './styles';

type LinkProps =
    | {
          to: string;
          href?: never;
      }
    | {
          to?: never;
          href: string;
      };

type BaseProps = {
    title: React.ReactNode;
    anchor?: () => HTMLElement;
    container?: () => HTMLElement;
    className?: string;
};

type Props = BaseProps & LinkProps;

const MenuItem: React.FC<PropsWithChildren<Props>> = ({ title, anchor, container, href, to, children, className }) => {
    const { classes, cx } = useStyles();
    const Component: React.ElementType = href ? 'a' : Link;
    const props = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : { to };
    return (
        <Tooltip
            placement="bottom"
            enterDelay={0}
            leaveDelay={100}
            PopperProps={{ container, anchorEl: anchor }}
            TransitionComponent={Fade}
            title={children ? children : null}
            classes={{ tooltip: classes.tooltip, popper: classes.popper }}
        >
            <Component {...props} className={cx(classes.root, className)}>
                {title}
            </Component>
        </Tooltip>
    );
};

export default MenuItem;
